import React, { Component } from "react";

import { Row, Col } from "react-bootstrap";

class CommonDataTableLoading extends Component {

    render = () => {

        let isLoading = this.props.isLoading;

        if (isLoading === false) return null;
        
        return (
            <Row className="data-table-progress-container">
                <Col md={12}>
                    <div className="data-table-progress-bar"></div>
                </Col>
            </Row>
        )
    }
}

export default CommonDataTableLoading;
